import React, { useMemo } from "react";
import Input from "../../../utils/components/Input";
import SelectBox from "../../../utils/components/SelectBox";
import { isArray } from "lodash";
import { IoMdCheckmarkCircleOutline, IoMdCloseCircleOutline, IoMdTrash } from "react-icons/io";

export default function ReportRowItem ({
  translate,
  roles,
  isNew,
  report,
  onReportChange,
  onSave,
  onDelete,
  onClose,
  isLoading = {},
}) {
  const isSaveButtonDisabled = useMemo(() => {
    if (!isNew) return true;

    return !(
      report.name?.trim() &&
      report.link?.trim() &&
      report.roles?.length > 0
    ) || isLoading.submit;
  }, [isNew, report, isLoading.submit]);

  const handleChange = (e) => {
    if (!onReportChange || !isNew) return;

    if (isArray(e)) {
      onReportChange("roles", e);
      return;
    }

    const { name, value } = e.target;
    onReportChange(name, value);
  };

  const formattedRoles = useMemo(() => {
    if (isNew) return report.roles || [];

    return report?.roles?.map(role => ({
      value: role.id,
      label: role.name,
    })) || [];
  }, [isNew, report?.roles]);

  const renderActionButtons = () => (
    <div className="d-flex justify-content-end align-items-center h-100">
      {isNew && (
        <button
          className={`btn btn-link p-0 me-2 ${isSaveButtonDisabled ? "text-muted" : "text-success"}`}
          disabled={isSaveButtonDisabled}
          onClick={onSave}
          title={translate("common.save")}
        >
          <IoMdCheckmarkCircleOutline size={24}/>
        </button>
      )}

      <button
        className={`btn btn-link p-0 ${isNew ? "text-dark" : "text-danger"}`}
        onClick={isNew ? onClose : onDelete}
        disabled={isLoading.delete}
        title={isNew ? translate("common.cancel") : translate("common.delete")}
      >
        {isNew ? (
          <IoMdCloseCircleOutline size={24}/>
        ) : (
          <IoMdTrash size={24}/>
        )}
      </button>
    </div>
  );

  return (
    <div className="ReportRowItem card p-3 border-0 shadow-sm">
      <div className="row g-3">
        <div className="col-12 col-md-3 col-lg-2">
          <label className="form-label small text-muted mb-1">
            {translate("project_settings.reports.report_name")}
          </label>
          <Input
            type="text"
            name="name"
            placeholder={translate("project_settings.reports.report_name")}
            value={report?.name || ""}
            onChange={handleChange}
            disabled={!isNew}
            className="form-control-sm"
          />
        </div>

        <div className="col-12 col-md-3 col-lg-3">
          <label className="form-label small text-muted mb-1">
            {translate("project_settings.reports.roles")}
          </label>
          <SelectBox
            options={roles}
            value={formattedRoles}
            isMulti={true}
            onChange={handleChange}
            placeholder={translate("project_settings.reports.roles")}
            className="custom-select form-select-sm"
            disabled={!isNew || isLoading.roles}
          />
        </div>

        <div className="col-12 col-md-3 col-lg-5">
          <label className="form-label small text-muted mb-1">
            {translate("project_settings.reports.report_link")}
          </label>
          <Input
            type="text"
            name="link"
            placeholder={translate("project_settings.reports.report_link")}
            value={report?.link || ""}
            onChange={handleChange}
            disabled={!isNew}
            className="form-control-sm"
          />
        </div>

        <div className="col-12 col-md-3 col-lg-2 d-flex align-items-end">
          {renderActionButtons()}
        </div>
      </div>
    </div>
  );
}